import moment from 'moment';

export class MakerDataListRequest {
    constructor(params) {
        this.paging = {
            pageNumber: params.pageIndex ?? null,
            pageSize: params.pageSize ?? null,
        };
        this.source = params.source ?? null;
        this.startDateTime = null;
        this.endDateTime = null;
        this.eventType = params.eventType ?? null;
        this.status = params.status ?? null;
        this.makerId = params.makerId ?? null;

        if (params.createdOn?.startDate && params.createdOn?.endDate) {
            this.startDateTime = moment(params.createdOn.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            this.endDateTime = moment(params.createdOn.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        this.dateRangeColumn = params.rangeType ?? null;
    }
}
